<template>
  <editable-box :mode="mode" position="rightTop" :includeBtns="['edit']" @onEdit="handelEdit">
    <div class="level-switch">
      <span class="label">{{ label }}</span>
      <span class="switch">
        <span class="btn prev-btn wiki-module-minus" @click="handlePrevLevel"></span>
        <span class="level">{{ currentLevelData.level || "--" }}</span>
        <span class="btn next-btn wiki-module-plus" @click="handleNextLevel"></span>
      </span>
      <!-- edit panel -->
      <edit-panel
        v-if="mode === 'edit'"
        ref="editPanel"
        :label="label"
        :data="data"
        :currentLevelData="currentLevelData"
        @onAddLevel="handleAddLevel"
        @onChangeLevel="handleChangeLevelItem"
        @onChangeLabel="hamdleChangelabel"
        @onEdit="handleEdit"
        @onDelete="handleDelete"
        @onChange="handleChangeLevel"
      ></edit-panel>
    </div>
  </editable-box>
</template>

<script>
// components
import EditableBox from "../../../../components/EditableBox/index.jsx";
import EditPanel from "./panel/EditPanel.vue";

export default {
  name: "LevelSwitch",
  components: {
    EditableBox,
    EditPanel
  },
  props: {
    mode: String,
    currentLevelData: {
      type: Object,
      default: () => ({})
    },
    label: String,
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    handelEdit() {
      this.$refs.editPanel.open();
    },
    handleAddLevel() {
      this.$emit("onAddLevel");
    },
    handleChangeLevelItem(index, level) {
      this.$emit("onChangeLevel", index, level);
    },
    handleChangeLevel(levelList) {
      this.$emit("onChange", levelList);
    },
    handlePrevLevel() {
      this.$emit("onPrev");
    },
    handleNextLevel() {
      this.$emit("onNext");
    },
    handleEdit(index) {
      this.$emit("onEdit", index);
    },
    handleDelete(index) {
      this.$emit("onDelete", index);
    },
    hamdleChangelabel(label) {
      this.$emit("onChangeLabel", label);
    }
  }
};
</script>

<style lang="less" scoped>
.level-switch {
  width: 100%;
  height: 22px;
  display: flex;
  align-items: center;
  .label {
    font-size: 14px;
    font-weight: 400;
    color: #373737;
    line-height: 22px;
    margin-right: 15px;
  }
  .switch {
    .btn {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 4px;
      vertical-align: middle;
      cursor: pointer;
    }
    .level {
      font-size: 14px;
      font-weight: bold;
      color: #373737;
      line-height: 22px;
      margin: 0 8px;
      vertical-align: middle;
    }
    .prev-btn {
    }
    .next-btn {
    }
  }
}
</style>
